import { DialogOptions, DialogStatic } from "../../@types/bootstrap-dialog";
interface BootstrapDialog extends DialogStatic {
    defaultOptions: DialogOptions
}


export class UserInterface {
    static init(): void {

        // Bootstrap Dialog Custom settings
        $.extend((BootstrapDialog as BootstrapDialog).defaultOptions, {
            closable: false,
            animate: false
        });

        // Remove whitespace around links
        document.querySelectorAll(".col-12.dv-action-line a.btn-link").forEach((element) => {
            element.innerHTML = element.innerHTML?.trim();
        });

        document.querySelectorAll("a.btn-back").forEach((element) => {
            element.addEventListener("click", () => { history.back(); });
        });
    }
}
